export const parseNumericParam = (param: string | undefined) => {
  if (param === undefined) return undefined;
  return Number(param);
};

export const isViewingPOS = () => window.location.hash === "#/pos";
